import { useEffect, useState } from "react";

/** Helps with SSR two-pass render and rehydration problem */
export function useHasMounted() {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}